import { apiProxyRequest } from "Api/apiProxyRequest";

export interface SubscriptionAddon {
  available: Available;
  upgrades_available: Available;
  current: Available;
}

export interface Available {
  big_dev: string[] | BigDevClass | null;
  backups: string[] | BackupsClass | null;
  big_dev_service: string[] | BigDevServiceClass | null;
  blackfire: string[] | BlackfireClass | null;
  continuous_profiling: string[] | ContinuousProfilingClass | null;
  observability_suite: string[] | ObservabilitySuiteClass | null;
}

export interface BackupsClass {
  Advanced: number;
  Premium: number;
}

export interface BigDevClass {
  Large: number;
  "X-Large": number;
}

export interface BigDevServiceClass {
  "2x-large-dev-service": number;
  "4x-large-dev-service": number;
  "large-dev-service": number;
  "medium-dev-service": number;
  "x-large-dev-service": number;
}

export interface BlackfireClass {
  Blackfire: number;
}

export interface ContinuousProfilingClass {
  "cont-profiling": number;
}

export interface ObservabilitySuiteClass {
  "obs-suite": number;
}

export const getAddonsRequest = (
  organizationId: string,
  subscriptionId: string
) =>
  apiProxyRequest<SubscriptionAddon>(
    `/organizations/${organizationId}/subscriptions/${subscriptionId}/addons`
  );
